import IConfigDataStore from '../IConfigDataStore'
import { API } from 'aws-amplify'

class ConfigDataStoreAWS extends IConfigDataStore {

  get = async () => {
    try {

      const res = await API.get('dreamportalsofview', '/portal/config/object', {
          response: true,
          headers: {
            Accept: 'application/json',
          }
      })
      if (res && res.data && res.data.config) {
        return res.data.config
      } else {
        throw new Error(`Config GET response missing 'config' attribute`)
      }
    }
    catch (error) {
      let res = {}
      if (error.response === undefined) {
        res = {status: '499', statusText: 'Industries GET Internal Error', error}
      } else {
        res = { status: error.response.status, statusText: error.response.data, message: error.message }
      }
      console.error('Error Config GET: ', JSON.stringify())
      return res
    }
  }
  
  retrieve() {
    return this.get()
  }

}

export default ConfigDataStoreAWS